import { FunctionComponent, useState } from 'react';
import { isValidWindowsFileName } from '@murphy-frontend/common/validation';
import * as React from 'react';
import Button from './Button';
import { IconContext } from 'react-icons/lib';
import { BiUpload } from 'react-icons/bi';
import Input from './Input';

interface FileUploadControlProps {
  onSubmit: (file: File) => void,
  translations?: Record<string, string>,
  onClose?: () => void
}

const FileUploadControl: FunctionComponent<FileUploadControlProps> = ({
  onSubmit,
  translations,
  onClose }) => {
  const [file, setFile] = useState<File>(null);
  const [fileValidationError, setFileValidationError] = useState('');
    const [nameErrorMessage, setNameErrorMessage] = useState("");
    const [extension, setExtension] = useState("");
    const [name, setName] = useState("");

  const selectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile: File = event.target.files[0];
    const fileSize = newFile.size / 1024 / 1024;
    if (fileSize > 50) {
      setFileValidationError(`Maximum file size ${50} MB.`);
      return;
    }
    const fileName = newFile.name;
    if (!isValidWindowsFileName(fileName)) {
      setFileValidationError('Filename is not a valid filename. Change the filename and upload again');
      return;
    }
    setFileValidationError('');

    setFile(newFile);
  };

  React.useEffect(() => {
    setName(file?.name || "")
    const oldExtension = file?.name?.split('.').pop();
    setExtension(oldExtension);
  }, [file])
  const submitFile = () => {
    setFileValidationError('');
    let f = file;
    if (name.length>0 && name !== file.name) {
      f = new File([file], name, {type: file.type});
    }
    onSubmit(f);
  }

    const onNameChanged = (event) => {
      const newName = event.target.value;
      if (!newName) {
        setNameErrorMessage("");
      } else {
        const newExtension = newName.split(".").pop();
        if (newExtension !== extension) {
          setNameErrorMessage(`The file extension must be .${extension}`);
        } else if (!isValidWindowsFileName(newName)) {
          setNameErrorMessage("Invalid filename");
        } else {
          setNameErrorMessage("");
        }
      }
      setName(newName);
    };

  return (
    <div className="file-control">
      <div>
        <label className="btn btn--medium btn-positive custom-file-upload" style={{display: 'flex', flexDirection: 'column'}}>
           <div className="btn-icon-container vertical-aligner">
                    <IconContext.Provider value={{ className: 'btn-icon' }}>
                      <BiUpload />
                    </IconContext.Provider>
                  </div>
          <input id="fileUploadInput" type="file" onChange={selectFile} style={{marginTop: 10}}/>
          {translations ? translations.choosefile : 'Browse file to upload'}
        </label>
      </div>
      {fileValidationError ? <div className="input-error-message">{fileValidationError}</div> : null}
      {file && <Input val={name} isRequired handleChange={(event) => onNameChanged(event)} errorMessage={nameErrorMessage} style={{borderWidth:1, borderColor: '#EBEBEB', width: '100%', borderStyle: 'solid', marginTop: 10, borderRadius: 5}}/>}
   
      <div className="modal-footer" style={{flexDirection: 'row', width: '100%', display: 'flex', marginTop: 20, justifyContent: 'center'}}>
      <Button buttonStyle="btn--cancel" buttonSize="btn--medium" onClick={onClose}>
          {translations ? translations.cancel : "Cancel"}
        </Button>
        <Button  disabled={!file || nameErrorMessage.length > 0} type="submit" buttonStyle="btn--primary" buttonSize="btn--medium" onClick={submitFile}>
        {translations ? translations.uploadfile : 'Upload file'}
        </Button>
       
      </div>
    </div>
  );
}

export default FileUploadControl;
